export default {
      id: "icon--sofa-slope-mapmarker-usage",
      viewBox: "0 0 22 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--sofa-slope-mapmarker-usage",
      toString: function () {
        return this.url;
      }
    }